import React, { useState, useEffect } from "react";
import HintsList from "./HintsList";
import SearchInput from "./SearchInput";
import { hintsService } from "./hintsService";

export function SearchHandler({ CustomRouter, isMobile }) {
    const [isActive, setIsActive] = useState(false);
    const [restoreHints, setRestoreHints] = useState(() => () => {}); // Инициализация пустой функции
    const [isLoading, setIsLoading] = useState(true); // Состояние загрузки
    const [productsCount, setProductsCount] = useState(null); // Количество товаров

    useEffect(() => {
        const loadProductsCount = async () => {
            const count = await hintsService.getProductsCount();
            setProductsCount(count);
        };
        
        loadProductsCount();
    }, []);

    return (
        <div className="menu-middle__search">
            <SearchInput 
                CustomRouter={CustomRouter} 
                setIsActive={setIsActive} 
                restoreHints={restoreHints} 
                isMobile={isMobile} 
                isLoading={isLoading} 
                productsCount={productsCount}
            />
            <HintsList CustomRouter={CustomRouter} isActive={isActive} setIsActive={setIsActive} setRestoreHints={setRestoreHints} setIsLoading={setIsLoading} />
        </div>
    );
}

